import { __awaiter } from "tslib";
import React from 'react';
import { createDagExtensionModule } from '../module';
import { useExtensionRegistry, XFlowAppExtensionModule } from '@antv/xflow-core';
export const DagGraphExtension = props => {
    /** 获取扩展Registry */
    const extensionRegistry = useExtensionRegistry();
    React.useEffect(() => {
        /** 添加 container的classname */
        extensionRegistry.addContainerClassNames('dag-extension-container');
        const layout = props.layout || 'TB';
        extensionRegistry.addContainerClassNames(layout === 'TB' ? 'layout-top-bottom' : 'layout-left-right');
    }, [extensionRegistry, props.layout]);
    const config = React.useMemo(() => ({
        CONFIG_TYPE: 'DAG_EXTENSION',
        getConfig: () => __awaiter(void 0, void 0, void 0, function* () { return props; }),
    }), [props]);
    return React.createElement(XFlowAppExtensionModule, { config: config, createModule: createDagExtensionModule });
};
//# sourceMappingURL=index.js.map